// src/components/YouTubePlayer.jsx

import ReactPlayer from 'react-player/youtube';
import React from 'react';
// Icons are no longer needed here

const YouTubePlayer = ({
    selectedSnippet,
    isPlaying,
    isMobile, // Keep for potential layout adjustments if needed later
    isMinimized // Keep to potentially pause/hide controls
    // Removed onClose, onToggleMinimize props
}) => {

    const placeholderClasses = `flex items-center justify-center text-base-content/60 italic bg-base-200/50 rounded-lg aspect-video`;

    if (!selectedSnippet || !selectedSnippet.video || !selectedSnippet.video.url) {
        return <div className={placeholderClasses}>{isMobile ? 'Select snippet' : ''}</div>;
    }

    // --- Player Setup ---
    const videoUrl = selectedSnippet.video.url;
    const startTime = Math.floor(Number(selectedSnippet.start_time) || 0);
    let videoId = null;
    let playerUrl = videoUrl;

    try {
        const urlObj = new URL(videoUrl);
        if (urlObj.hostname.includes('youtube.com') || urlObj.hostname.includes('youtu.be')) {
            videoId = urlObj.searchParams.get('v') || urlObj.pathname.substring(1);
            playerUrl = `https://www.youtube.com/watch?v=${videoId}`; // Use standard URL
        }
    } catch (e) {
        console.error("Error parsing video URL:", e, videoUrl);
        playerUrl = videoUrl;
    }

    // --- Styling ---
    // Wrapper is simpler now, just holds the player container
    const wrapperClasses = `bg-black rounded-lg overflow-hidden shadow-lg h-full w-full`; // Ensure it fills its parent
    // Player container uses aspect-video
    const playerContainerClasses = `player-container relative aspect-video w-full h-full ${isMinimized ? 'opacity-60 pointer-events-none' : 'opacity-100'} transition-opacity duration-300`; // Fade slightly when minimized

    const playerSizeProps = { width: '100%', height: '100%' };
    const playerStyles = { position: 'absolute', top: 0, left: 0 };
    const playerConfig = {
        youtube: {
            playerVars: {
                start: startTime,
                modestbranding: 1,
                rel: 0,
                playsinline: 1
            }
        }
    };

    return (
        <div className={wrapperClasses}>
            {/* Removed button container */}
            <div className={playerContainerClasses}>
                {playerUrl ? (
                    <ReactPlayer
                        key={selectedSnippet.id}
                        url={playerUrl}
                        playing={isPlaying && !isMinimized} // Still pause when minimized
                        controls={!isMinimized} // Still hide controls when minimized
                        config={playerConfig}
                        {...playerSizeProps}
                        style={playerStyles}
                        // Removed onEnded={onClose} as onClose is removed
                        onError={(e) => {
                            console.error("YouTubePlayer Error:", e, playerUrl);
                            // Cannot call onClose here anymore
                        }}
                        pip={true}
                    />
                ) : (
                     <div className="flex items-center justify-center text-base-content/60 italic bg-base-200/50 aspect-video">Error loading video.</div>
                )}
            </div>
            {/* Removed title display from here, can be added in PlayerPage if needed */}
        </div>
    );
};

export default YouTubePlayer;
